<template>
  <section>
    <v-container id="container" fluid>
      <v-row
        id="toi"
        align="center"
        justify="center"
        class="pt-5 pt-md-15"
      >
        <v-col cols="12" md="8">
          <v-container class="fill-height">
            <v-row justify="left" class="mb-5">
              <v-col cols="11" class="py-0 mt-10 my-md-15">
                <div class="d-inline-flex">
                  <v-img
                    contain
                    height="100"
                    class="mb-5 pa-0"
                    src="@/assets/logos/horz/toi.svg"
                  ></v-img>
                </div>
                <div>
                  {{ $t("proyectos.toi") }}
                </div>
                <v-btn
                  href="https://www.toipastores.es/"
                  target="_blank"
                  class="accent my-5"
                  >{{ $t("info.verSitio") }}</v-btn
                >
              </v-col>
            </v-row>
          </v-container>
        </v-col>
        <v-col
          cols="12"
          md="3"
          align-self="center"
          class="pt-5 pt-md-15 shape verdeFondo"
        >
          <v-img
            contain
            height="300"
            src="@/assets/img/proyectos/toi/screen-toi.png"
          >
          </v-img>
        </v-col>
        <!-- <div class="my-10">
          <v-btn outlined class="ma-2" to="/pariciones"
            >pariciones<v-icon right>
              mdi-chevron-left
            </v-icon></v-btn
          >
          <v-btn outlined class="ma-2" to="/ebersy"
            ><v-icon left> mdi-chevron-right </v-icon>ebersy</v-btn
          >
        </div> -->
      </v-row>
    </v-container>
  </section>
</template>

<script>
export default {
  name: "Toi",
};
</script>

<style scoped>
#toi {
  min-height: 100vh;
}
.shape {
  border-radius: 30% 70% 67% 33% / 30% 30% 70% 70%;
  background-position: top right;
  width: 200px;
}
</style>
